<template>
  <van-overlay :show="isShowVideo" @click="hideVideo">
    <div v-if="isShowVideo" class="overlay-wrap" @click.stop>
      <div class="video-wrap">
        <video
          class="video"
          controls
          webkit-playsinline="true"
          playsinline="true"
          x5-video-player-type="h5-page"
          x5-video-player-fullscreen="true"
          t7-video-player-type="inline"
          x-webkit-airplay="true"
          src="https://jobs.jin10.com/video/appVideo.mp4"
        >
          <!-- <source src="" type="video/mp4" /> -->
        </video>
        <div class="close-icon" @click="hideVideo" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    isShowVideo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideVideo() {
      this.$emit('update:isShowVideo', false)
    }
  }
}
</script>

<style lang="scss" scoped >
.overlay-wrap {
  position: relative;
  width: 100%;
  height: 100%;
.video-wrap {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 90vw;
    height: auto;
  .video {
    // position: absolute;
    // top: 66.98vw;
    // left: 4.5vw;
    // width: 90.34vw;
    // height: 50.81vw;
    width: 100%;
    height: 100%;
    background-color: #000;
    // margin: 66.98vw 0 0 4.5vw;
  }
  .close-icon {
    margin: 30px auto 0;
    width: 28px;
    height: 28px;
    background: url("~@/assets/index/hVideo/关闭2@2x.png") 100% no-repeat;
    background-size: 100% 100%;
  }
}
}
</style>
